'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = pascalize;

var _camelize = require('./camelize');

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */
function pascalize(str) {
  return (0, _camelize2['default'])('-' + str);
}


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/utils/pascalize.js
// module id = 9
// module chunks = 0